<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">{{ modalLabel }} </span>
    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="body-modal cutomBtn-margin">
    <form [formGroup]="importForm">
      <div class="row">
        <div *ngIf="templateType == ImportTypeEnum.MasterTemplate">
          <div *ngIf="isImport" class="col-sm-12">
            <div
              class="form-group required"
              *ngIf="selectedImportList$ | async as selectedImportList"
            >
              <label *ngIf="importForm.get('organization')?.value" class="sub-header-drpdown pb-2"
                >Organization</label
              >
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #organization
                [items]="selectedImportList.data.organizationItems"
                [searchable]="false"
                bindLabel="name"
                bindValue="id"
                formControlName="organization"
                [searchFn]="commonInputSearch"
                placeholder="Select organization *"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      type="text"
                      class="accordion-search form-control search-input dropdown-search-design"
                      id="inputValidation"
                      placeholder="Search..."
                      (input)="organization.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="submitted && importForm.controls['organization']?.invalid"
                class="input-error"
              >
                Organization is required.
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div
      class="row"
      *ngIf="
        templateType == ImportTypeEnum.CustomTemplate ||
        templateType == ImportTypeEnum.PiqetTemplate
      "
    >
      <div class="col-sm-12" *ngIf="checkPiqetTemplateAccess && checkCustomTemplateAccess">
        <div class="form-group">
          <label class="sub-header-drpdown pb-2">Template Type</label>
          <div class="template-toggle-container d-flex align-items-center">
            <div class="template-toggle-container d-flex align-items-center">
              <ng-container
                *ngIf="templateToggleType === ImportTypeEnum.CustomTemplate; else piqetFirst"
              >
                <button
                  type="button"
                  class="toggle-button"
                  [class.active]="true"
                  (click)="onTemplateTypeChange(ImportTypeEnum.CustomTemplate)"
                  [ngClass]="
                    templateType == ImportTypeEnum.CustomTemplate
                      ? ' modelBtn  purpleBtnHoverEffect'
                      : 'cancelBtn'
                  "
                >
                  Custom Template
                </button>
                <button
                  type="button"
                  class="toggle-button ml-3"
                  [class.active]="false"
                  (click)="onTemplateTypeChange(ImportTypeEnum.PiqetTemplate)"
                  [ngClass]="
                    templateType == ImportTypeEnum.PiqetTemplate
                      ? ' modelBtn  purpleBtnHoverEffect'
                      : 'cancelBtn'
                  "
                >
                  Piqet Template
                </button>
              </ng-container>
              <ng-template #piqetFirst>
                <button
                  type="button"
                  class="toggle-button"
                  [class.active]="true"
                  (click)="onTemplateTypeChange(ImportTypeEnum.PiqetTemplate)"
                  [ngClass]="
                    templateType == ImportTypeEnum.PiqetTemplate
                      ? ' modelBtn  purpleBtnHoverEffect'
                      : 'cancelBtn'
                  "
                >
                  Piqet Template
                </button>
                <button
                  type="button"
                  class="toggle-button ml-3"
                  [class.active]="false"
                  (click)="onTemplateTypeChange(ImportTypeEnum.CustomTemplate)"
                  [ngClass]="
                    templateType == ImportTypeEnum.CustomTemplate
                      ? ' modelBtn  purpleBtnHoverEffect'
                      : 'cancelBtn'
                  "
                >
                  Custom Template
                </button>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="templateType === ImportTypeEnum.CustomTemplate" class="col-sm-6">
        <div class="form-group required">
          <div class="project-spacing selctstops02">
            <label *ngIf="selectedTemplate" class="sub-header-drpdown pb-2">Template</label>
            <label *ngIf="!selectedTemplate" class="placeholder-sub-header pb-2"
              >Select template</label
            >

            <ng-select
              [(ngModel)]="selectedTemplate"
              (ngModelChange)="onTemplateChange()"
              (blur)="onTemplateBlur()"
              [clearable]="true"
              [clearOnBackspace]="false"
              #shareList
              [items]="importLogListData"
              [searchable]="false"
              bindLabel="name"
              [searchFn]="commonInputSearch"
              placeholder="Select a Template *"
              (change)="selectTemplate($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="shareList.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>

              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                  {{ item.name }}
                </div>
              </ng-template>
            </ng-select>
          </div>
          <div
            class="input-error"
            *ngIf="
              templateTouched && !selectedTemplate && templateType === ImportTypeEnum.CustomTemplate
            "
          >
            Please select a Piqet template.
          </div>
        </div>
      </div>

      <div *ngIf="templateType === ImportTypeEnum.CustomTemplate" class="col-sm-6">
        <div class="form-group required">
          <div class="project-spacing selctstops02">
            <label *ngIf="selectedWeight" class="sub-header-drpdown pb-2">Weight type</label>
            <label *ngIf="!selectedWeight" class="placeholder-sub-header pb-2"
              >Select weight type</label
            >

            <ng-select
              [clearable]="false"
              [(ngModel)]="selectedWeight"
              (ngModelChange)="onWeightChange()"
              (blur)="onWeightBlur()"
              [clearOnBackspace]="false"
              #weightSelect
              [items]="weightTypes"
              [searchable]="false"
              bindLabel="label"
              placeholder="Select Weight Type *"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="weightSelect.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>

              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.label }}">
                  {{ item.label }}
                </div>
              </ng-template>
            </ng-select>
          </div>
          <div
            class="input-error"
            *ngIf="
              weightTouched && !selectedWeight && templateType === ImportTypeEnum.CustomTemplate
            "
          >
            Please select a weight type.
          </div>
        </div>
      </div>

      <div *ngIf="templateType === ImportTypeEnum.CustomTemplate" class="col-sm-6">
        <div class="services-form">
          <input
            type="number"
            placeholder="Enter starting row index"
            name="startRow"
            [(ngModel)]="startRow"
            (ngModelChange)="validateField()"
            (blur)="startRowTouched = true"
            required
          />
          <label class="col-sm-6 col-form-label">Start row index</label>
        </div>
        <div
          class="input-error"
          *ngIf="
            startRowTouched &&
            (!startRow || startRow < 1) &&
            templateType === ImportTypeEnum.CustomTemplate
          "
        >
          Start row index must be 1 or greater
        </div>
      </div>

      <div *ngIf="templateType === ImportTypeEnum.CustomTemplate" class="col-sm-6">
        <div class="services-form">
          <input
            type="number"
            placeholder="Enter ending row index"
            name="endRow"
            [(ngModel)]="endRow"
            (ngModelChange)="validateField()"
            (blur)="endRowTouched = true"
            required
          />
          <label class="col-sm-6 col-form-label">End row index</label>
        </div>
        <div
          class="input-error"
          *ngIf="
            endRowTouched &&
            (!endRow || endRow < 1) &&
            templateType === ImportTypeEnum.CustomTemplate
          "
        >
          End row index must be 1 or greater
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-sm-6">
        <label class="upload-text">
          <span *ngIf="templateType === ImportTypeEnum.PiqetTemplate"
            >Upload the excel file to import to the system</span
          >
          <span *ngIf="templateType === ImportTypeEnum.CustomTemplate"
            >Upload your custom template file</span
          >
          <span
            *ngIf="
              templateType === ImportTypeEnum.MasterTemplate ||
              templateType === ImportTypeEnum.MappingTemplate
            "
            >Upload the excel file to import to the system</span
          >
        </label>
        <div class="fileinput fileinput-new">
          <div class="input-group input-large">
            <div
              class="form-control uneditable-input d-flex justify-content-flex-start align-items-center text-decoration-underline"
              data-trigger="fileinput"
            >
              <i class="fa fa-file fileinput-exists" *ngIf="isShowChange && !extFile"></i>
              <span *ngIf="!!selectedFiles && !extFile" class="fileinput-filename"
                >&nbsp; {{ selectedFiles }}</span
              >
            </div>
            <span class="btn default btn-file">
              <input
                type="file"
                (change)="onFileSelected($event, hiddenfileinput)"
                style="display: none"
                #hiddenfileinput
                accept=".xls, .xlsx, .csv, .xlsm"
              />
              <button
                class="btn-style"
                (click)="hiddenfileinput.click()"
                style="padding: 0px; color: white; width: 140px !important; border-radius: 0px"
                class="waves-effect btn selectFile"
                *ngIf="!isShowChange || extFile"
              >
                Select file
              </button>
              <button
                class="btn-width"
                *ngIf="isShowChange && !extFile"
                style="padding: 0px; color: white; width: 100px !important; border-radius: 0px"
                (click)="hiddenfileinput.click()"
                class="waves-effect waves-light btn changeFile"
              >
                Change
              </button>
            </span>
            <button
              class="btn"
              (click)="removeImage(hiddenfileinput)"
              *ngIf="isShowChange && !extFile"
              class="waves-effect waves-light btn removeBtn"
            >
              Remove
            </button>
          </div>
        </div>
        <div *ngIf="extFile">
          <span id="PiqetValidationSummary" class="input-error"
            >Only .xls, .xlsx, .csv, .xlsm file allowed</span
          >
        </div>
      </div>
    </div>

    <div class="row mt-4" *ngIf="importErrors?.length && !isLoading">
      <div class="error-notification-container" style="width: 100%">
        <div class="error-grid-header" style="width: 100%">
          <div class="error-header-item" style="width: 30%">Category</div>
          <div class="error-header-item" style="width: 15%">Cell address</div>
          <div class="error-header-item" style="width: 50%">Error message</div>
        </div>

        <div class="error-content-main">
          <div *ngFor="let group of getGroupedErrors(importErrors)">
            <div
              class="error-grid-item"
              style="width: 100%; font-weight: bold; background-color: #fdfafa"
            >
              <div class="error-title" style="width: 30%">Sheet name: {{ group.sheetName }}</div>
              <div class="error-title" style="width: 15%">&nbsp;</div>
              <div class="error-title" style="width: 50%">&nbsp;</div>
            </div>

            <div *ngFor="let error of group.errors" class="error-grid-item" style="width: 100%">
              <div class="error-title" style="width: 30%">
                {{ error.category }}
              </div>
              <div class="error-content" style="width: 15%">
                {{ error.location }}
              </div>
              <div class="error-content" style="width: 50%">
                {{ error.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="importMessage && importErrors?.length == 0" class="import-status-message">
      {{ importMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button
      type="button"
      class="modelBtn purpleBtnHoverEffect"
      [disabled]="isLoading || importErrors?.length >= 1"
      (click)="onSave()"
    >
      <ng-container *ngIf="isLoading; else importText">
        Import &nbsp;
        <span
          class="spinner-border spinner-border-sm spinner-css"
          role="status"
          aria-hidden="true"
        ></span>
      </ng-container>
      <ng-template #importText>Import</ng-template>
    </button>
  </div>
</div>
